import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Coordinates the mobile nav open/closed state between the header (hamburger) and the profile nav sibling components.
@Injectable({ providedIn: 'root' })
export class ProfileNavStateService {
  private readonly mobileNavOpenSubject = new BehaviorSubject<boolean>(false);
  readonly mobileNavOpen$ = this.mobileNavOpenSubject.asObservable();

  toggle(): void {
    this.mobileNavOpenSubject.next(!this.mobileNavOpenSubject.value);
  }

  close(): void {
    this.mobileNavOpenSubject.next(false);
  }
}
